import { render, staticRenderFns } from "./index.html?vue&type=template&id=72cfebc0&scoped=true&external"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./index.vue?vue&type=style&index=0&id=72cfebc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cfebc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72cfebc0')) {
      api.createRecord('72cfebc0', component.options)
    } else {
      api.reload('72cfebc0', component.options)
    }
    module.hot.accept("./index.html?vue&type=template&id=72cfebc0&scoped=true&external", function () {
      api.rerender('72cfebc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-label-value-wrapper/index.vue"
export default component.exports